const ONYX_PLATE = {
  slug: "onyx-plate",
  name: "Onyx Plate",
  description: "Forged in the deepest mines",
  rarity: "uncommon",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 15 },
    { stat: "blackColor", value: 8 },
    { stat: "blackRes", value: 3 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_black",
    frameIndex: 1
  },
  bodySprite: "characters/body/body_black",
  tags: ["daily-rotation", "metal"]
};
export {
  ONYX_PLATE
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9vbnl4LXBsYXRlLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJpbXBvcnQgeyBJdGVtRGVmaW5pdGlvbiB9IGZyb20gJy4uLy4uL3R5cGVzJztcblxuZXhwb3J0IGNvbnN0IE9OWVhfUExBVEU6IEl0ZW1EZWZpbml0aW9uID0ge1xuICBzbHVnOiAnb255eC1wbGF0ZScsXG4gIG5hbWU6ICdPbnl4IFBsYXRlJyxcbiAgZGVzY3JpcHRpb246ICdGb3JnZWQgaW4gdGhlIGRlZXBlc3QgbWluZXMnLFxuICByYXJpdHk6ICd1bmNvbW1vbicsXG4gIHNsb3Q6ICdhcm1vcicsXG4gIHNob3BDYXRlZ29yeTogJ21ldGFsLWFybW9yJyxcbiAgc3RhdENoYW5nZXM6IFtcbiAgICB7IHN0YXQ6ICdhcm1vcicsIHZhbHVlOiAxNSB9LFxuICAgIHsgc3RhdDogJ2JsYWNrQ29sb3InLCB2YWx1ZTogOCB9LFxuICAgIHsgc3RhdDogJ2JsYWNrUmVzJywgdmFsdWU6IDMgfSxcbiAgXSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3YXJkcm9iZS9tZXRhbC9tZXRhbF9ibGFjaycsXG4gICAgZnJhbWVJbmRleDogMSxcbiAgfSxcbiAgYm9keVNwcml0ZTogJ2NoYXJhY3RlcnMvYm9keS9ib2R5X2JsYWNrJyxcbiAgdGFnczogWydkYWlseS1yb3RhdGlvbicsICdtZXRhbCddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQUVPLE1BQU0sYUFBNkI7QUFBQSxFQUN4QyxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixRQUFRO0FBQUEsRUFDUixNQUFNO0FBQUEsRUFDTixjQUFjO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWCxFQUFFLE1BQU0sU0FBUyxPQUFPLEdBQUc7QUFBQSxJQUMzQixFQUFFLE1BQU0sY0FBYyxPQUFPLEVBQUU7QUFBQSxJQUMvQixFQUFFLE1BQU0sWUFBWSxPQUFPLEVBQUU7QUFBQSxFQUMvQjtBQUFBLEVBQ0EsUUFBUTtBQUFBLElBQ04sT0FBTztBQUFBLElBQ1AsWUFBWTtBQUFBLEVBQ2Q7QUFBQSxFQUNBLFlBQVk7QUFBQSxFQUNaLE1BQU0sQ0FBQyxrQkFBa0IsT0FBTztBQUNsQzsiLAogICJuYW1lcyI6IFtdCn0K
